import React, {useEffect, useState} from "react";
import SideBar from "../../../ui/sidebar/sidebar";
import UserHeader from "../../../components/user/header/userheader/userheader";
import useMediaQuery from '@mui/material/useMediaQuery';
import {NavLink} from "react-router-dom";
import {DashboardManagementIcon} from "../../../modules/icons/dashboardmanagement";
import {ContentManagementIcon} from "../../../modules/icons/contentmanagement";
import {FinancialDepartmentIcon} from "../../../modules/icons/financialdepartment";
import {AccountSettingIcon} from "../../../modules/icons/accountsetting";
import {TijarAssistantIcon} from "../../../modules/icons/tijarassistant";
import {AccountLogoutIcon} from "../../../modules/icons/accountlogout";
import HorizontalDivider from "../../../ui/horizontaldivider/horizontaldivider";
import "../styles/publisherlayout.scss";
import DisplayIcon from "../../../modules/icons/display";

interface IPublisher {
    children: React.ReactNode
}

const PublisherLayout = ({children}: IPublisher) => {
    useEffect(() => {
        document.body.style.backgroundColor = "#E5E5E5"
    }, [])
    const matches = useMediaQuery('(max-width:768px)');
    const [open, setOpen] = useState(!matches);
    const sidebarBody = (
        <div className="d-flex justify-content-end align-items-start flex-column SideBar-Content mt-3">
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/publisher/dashboard">
                <DashboardManagementIcon/>
                داشبورد مدیریت
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/publisher/ad-stations">
                <DisplayIcon/>
                جایگاه های تبلیغاتی
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/ad-management">
                <ContentManagementIcon/>
                مدیریت تبلیغات
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/financial-department">
                <FinancialDepartmentIcon/>
                امور مالی
            </NavLink>
            <HorizontalDivider/>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/account-setting">
                <AccountSettingIcon/>
                تنظیمات حساب کاربری
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/tijar-assistant">
                <TijarAssistantIcon/>
                دستیار تیجار
            </NavLink>
            <NavLink onClick={matches ? () => setOpen(!open) : () => {
                return null
            }} className="nav-link" to="/user/guide">
                <FinancialDepartmentIcon/>
                راهنما
            </NavLink>
            <NavLink onClick={matches ?
                () => {
                    setOpen(!open);
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('userType');
                } :
                () => {
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('userType');
                }} className="nav-link" to="/" replace>
                <AccountLogoutIcon/>
                خروج از حساب کاربری
            </NavLink>
        </div>
    )
    return (
        <>
            <SideBar panelChangeTitle={"تغییر به پنل تبلیغ دهنده"} panelChangeTarget={"user"} inside={sidebarBody}
                     credit={"1,500,000 تومان"} open={open} close={() => setOpen(!open)}/>
            <div className="Publisher-Content">
                <UserHeader open={open} setOpen={setOpen} job={"ناشر"}
                            profile={require("../../../assets/images/avatars/Avatar14.png")}
                            credit={"1,500,000 تومان"} name={"احسان رضایی"} notification={true}/>
                <div className="container px-4">
                    {children}
                </div>
            </div>
        </>
    );
}

export default PublisherLayout;